import React from 'react';
import { USERCENTRICS_WEB_CMP_LOADER_SCRIPT_URL } from '../constants.js';
/**
 * The script tag that loads the Usercentrics Browser UI & API.
 *
 * @example <caption>Default production mode</caption>
 * () => <UsercentricsScript settingsId="1234" />
 *
 * @example <caption>Preview mode for development</caption>
 * () => <UsercentricsScript settingsId="1234" version="preview" />
 *
 * @example <caption>Fixed language code</caption>
 * () => <UsercentricsScript settingsId="1234" language="fi" />
 *
 */
export const UsercentricsScript = ({ id = 'usercentrics-cmp', language, settingsId, version, ...rest }) => {
    return (React.createElement("script", { ...rest, async: 'async' in rest ? rest.async : true, "data-language": language, "data-settings-id": settingsId, "data-version": version, id: id, src: USERCENTRICS_WEB_CMP_LOADER_SCRIPT_URL }));
};
